import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getBusinessType from '@results/selectors/getBusinessType';
import { NOT_SET } from '@utils/tracking/constants';

const EVENT = 'swimlane.swiped';

const trackSwimlaneSwiped = ({
  screenType = NOT_SET,
  title = NOT_SET,
  type = NOT_SET,
  position = 0,
  products = [],
} = {}) => (_, getState) => {
  try {
    const state = getState();
    const shopId = getShopId(state);
    const businessType = getBusinessType(state);
    const payload = {
      shopId,
      businessType,
      screenType,
      swimlaneTitle: title,
      swimlaneType: type,
      position,
      swimlaneContent: products.map(product => product.id).toString(),
    };
    track(EVENT, payload);
  } catch (error) {
    logError(EVENT, error);
  }
};

export default trackSwimlaneSwiped;
